import {
  NotificationsList,
  defaultNotifier,
  TNotificationId,
  INotification,
  TDispatchedNotification,
  TNotificationSelector,
} from '@apia/notifications';
import type { ApiaUtil } from '..';

export class ApiaUtilNotifications {
  constructor(protected util: ApiaUtil) {}

  close = (id: TNotificationId | INotification) => {
    defaultNotifier.close(id);
  };

  closeAll = () => {
    defaultNotifier.closeAll();
  };

  notify = (notification: TDispatchedNotification): void => {
    if (notification.type === 'modal') {
      this.util.modals.open({
        size: 'flex',
        html: notification.message,
        title: notification.title || '',
        onConfirm: () => {},
        onClose:notification.onClose,
        confirmProps: {
          hideCancelButton: true,
        },
      });
    } else {
      defaultNotifier.notify({
        ...notification,
        type: notification.type ?? 'warning',
      });
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  useSelector = (selector: TNotificationSelector<any>) =>
    defaultNotifier.useSelector(selector);

  Component = () => {
    return <NotificationsList />;
  };
}
